(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  function matchBreadcrumbsToFirstSection() {
    document.querySelectorAll('[data-breadcrumbs-match-first-section="true"]').forEach((breadcrumbs) => {
      const firstBackground = document.querySelector('main .shopify-section .section-background');

      if (!firstBackground) return;

      const sourceStyles = getComputedStyle(firstBackground);
      const properties = [
        '--color-background',
        '--color-background-rgb',
        '--color-foreground',
        '--color-foreground-rgb',
        '--color-border',
        '--color-border-rgb',
      ];

      properties.forEach((property) => {
        const value = sourceStyles.getPropertyValue(property);
        if (value) breadcrumbs.style.setProperty(property, value);
      });

      breadcrumbs.style.backgroundColor = sourceStyles.backgroundColor;
      breadcrumbs.style.color = sourceStyles.color;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', matchBreadcrumbsToFirstSection);
  } else {
    matchBreadcrumbsToFirstSection();
  }

  document.addEventListener('shopify:section:load', matchBreadcrumbsToFirstSection);
  document.addEventListener('shopify:section:reorder', matchBreadcrumbsToFirstSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
